/* SM — Page produit "Sleep Mask" (Gesty 2.0)
   Composants autonomes : galerie, variantes, offres de lot, accordéon, barre collante. */
(function () {
  'use strict';

  var money = function (cents, format) {
    try {
      if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents, format);
    } catch (e) {}
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  };

  /* ---------------------------------------------------------------- Galerie */
  if (!customElements.get('sm-gallery')) {
    customElements.define('sm-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-sm-track]');
        if (!this.track) return;
        this.slides = Array.from(this.querySelectorAll('[data-sm-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-sm-thumb]'));
        this.dots = Array.from(this.querySelectorAll('[data-sm-dot]'));
        this.prev = this.querySelector('[data-sm-prev]');
        this.next = this.querySelector('[data-sm-next]');
        this.index = 0;

        var go = this.goTo.bind(this);
        if (this.prev) this.prev.addEventListener('click', function () { go(this.index - 1); }.bind(this));
        if (this.next) this.next.addEventListener('click', function () { go(this.index + 1); }.bind(this));
        this.thumbs.concat(this.dots).forEach(function (el) {
          el.addEventListener('click', function () { go(parseInt(el.dataset.index, 10)); });
        });
        this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        this.addEventListener('sm:media', function (e) { go(e.detail.index); });
        this.sync();
      }
      goTo(i) {
        if (i < 0 || i >= this.slides.length) return;
        this.index = i;
        this.track.scrollTo({ left: this.slides[i].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.sync();
      }
      onScroll() {
        clearTimeout(this._t);
        this._t = setTimeout(function () {
          var mid = this.track.scrollLeft + this.track.clientWidth / 2;
          var best = 0, bestD = Infinity;
          this.slides.forEach(function (s, i) {
            var c = s.offsetLeft - this.track.offsetLeft + s.clientWidth / 2;
            var d = Math.abs(c - mid);
            if (d < bestD) { bestD = d; best = i; }
          }.bind(this));
          this.index = best;
          this.sync();
        }.bind(this), 90);
      }
      sync() {
        this.thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === this.index ? 'true' : 'false'); }.bind(this));
        this.dots.forEach(function (d, i) { d.setAttribute('aria-current', i === this.index ? 'true' : 'false'); }.bind(this));
        if (this.prev) this.prev.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.slides.length - 1;
      }
    });
  }

  /* ------------------------------------------------------- Sélecteur variantes */
  if (!customElements.get('sm-variants')) {
    customElements.define('sm-variants', class extends HTMLElement {
      connectedCallback() {
        var raw = this.querySelector('[type="application/json"]');
        this.variants = raw ? JSON.parse(raw.textContent) : [];
        this.root = this.closest('[data-sm-product]') || document;
        this.swatches = Array.from(this.querySelectorAll('[data-sm-swatch]'));
        this.swatches.forEach(function (b) {
          b.addEventListener('click', this.pick.bind(this, b));
        }.bind(this));
      }
      pick(btn) {
        var id = parseInt(btn.dataset.variantId, 10);
        var v = this.variants.filter(function (x) { return x.id === id; })[0];
        if (!v) return;
        this.swatches.forEach(function (s) { s.setAttribute('aria-checked', s === btn ? 'true' : 'false'); });
        var label = this.querySelector('[data-sm-swatch-value]');
        if (label) label.textContent = btn.dataset.variantTitle || '';

        var input = this.root.querySelector('[data-sm-variant-id]');
        if (input) input.value = v.id;

        var img = this.root.querySelector('[data-sm-gallery]');
        if (img && btn.dataset.mediaIndex) {
          img.dispatchEvent(new CustomEvent('sm:media', { detail: { index: parseInt(btn.dataset.mediaIndex, 10) } }));
        }
        this.root.dispatchEvent(new CustomEvent('sm:variant', { bubbles: true, detail: { variant: v } }));

        if (v.url && window.history.replaceState) {
          window.history.replaceState({}, '', v.url);
        }
      }
    });
  }

  /* ------------------------------------------------------------ Offres de lot */
  if (!customElements.get('sm-bundles')) {
    customElements.define('sm-bundles', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('[data-sm-product]') || document;
        this.cards = Array.from(this.querySelectorAll('[data-sm-bundle]'));
        this.cards.forEach(function (c) {
          c.addEventListener('click', function (e) {
            if (e.target.closest('select')) return;
            this.select(c);
          }.bind(this));
        }.bind(this));
        var pre = this.cards.filter(function (c) { return c.dataset.selected === 'true'; })[0] || this.cards[0];
        if (pre) this.select(pre);
        this.root.addEventListener('sm:variant', this.refresh.bind(this));
      }
      select(card) {
        this.cards.forEach(function (c) {
          var on = c === card;
          c.dataset.selected = on ? 'true' : 'false';
          var r = c.querySelector('[data-sm-bundle-input]');
          if (r) r.checked = on;
          var extras = c.querySelector('[data-sm-bundle-extras]');
          if (extras) extras.hidden = !on;
        });
        this.current = card;
        var qty = this.root.querySelector('[data-sm-quantity]');
        if (qty) qty.value = card.dataset.quantity || '1';
        var prop = this.root.querySelector('[data-sm-offer-prop]');
        if (prop) prop.value = card.dataset.label || '';
        this.refresh();
      }
      refresh() {
        if (!this.current) return;
        var unit = parseInt(this.current.dataset.unitPrice || '0', 10);
        var total = parseInt(this.current.dataset.totalPrice || '0', 10);
        this.root.dispatchEvent(new CustomEvent('sm:total', { bubbles: true, detail: { total: total, unit: unit } }));
      }
    });
  }

  /* ------------------------------------------------------------ Prix / bouton */
  document.addEventListener('DOMContentLoaded', function () {
    Array.from(document.querySelectorAll('[data-sm-product]')).forEach(function (root) {
      var fmt = root.dataset.moneyFormat || '';
      root.addEventListener('sm:variant', function (e) {
        var v = e.detail.variant;
        var now = root.querySelector('[data-sm-price-now]');
        var was = root.querySelector('[data-sm-price-was]');
        var save = root.querySelector('[data-sm-price-save]');
        if (now) now.textContent = money(v.price, fmt);
        if (was) {
          var has = v.compare_at_price && v.compare_at_price > v.price;
          was.hidden = !has;
          if (has) was.textContent = money(v.compare_at_price, fmt);
          if (save) {
            save.hidden = !has;
            if (has) save.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
          }
        }
        Array.from(root.querySelectorAll('[data-sm-atc]')).forEach(function (btn) {
          btn.disabled = !v.available;
          var t = btn.querySelector('[data-sm-atc-text]');
          if (t) t.textContent = v.available ? (btn.dataset.defaultText || t.textContent) : (btn.dataset.soldoutText || t.textContent);
        });
      });
      root.addEventListener('sm:total', function (e) {
        Array.from(root.querySelectorAll('[data-sm-atc-total]')).forEach(function (el) {
          el.textContent = money(e.detail.total, fmt);
        });
      });
    });
  });

  /* ---------------------------------------------------------------- Accordéon */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sm-acc-btn]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    panel.hidden = open;
  });

  /* ----------------------------------------------------------- Barre collante */
  if (!customElements.get('sm-sticky-bar')) {
    customElements.define('sm-sticky-bar', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('[data-sm-sticky]');
        this.form = document.querySelector(this.dataset.form || 'form[data-sm-product-form]');
        var watch = document.querySelector(this.dataset.watch || '[data-sm-buy-block]');
        if (!this.bar || !watch) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            this.bar.dataset.visible = en.isIntersecting ? 'false' : 'true';
          }.bind(this));
        }.bind(this), { rootMargin: '0px 0px -85% 0px' });
        io.observe(watch);
        var submit = this.querySelector('[data-sm-sticky-submit]');
        if (submit && this.form) {
          submit.addEventListener('click', function () {
            if (this.form.requestSubmit) this.form.requestSubmit(); else this.form.submit();
          }.bind(this));
        }
      }
    });
  }
})();
